import { Axios } from "axios";
import { CherryPayApi } from "./models";
import { ApiResult, apiResult } from "./apiClient";

export class SegmentApiClient {
  private cherryPayClient: Axios;

  constructor(cherryPayClient: Axios) {
    this.cherryPayClient = cherryPayClient;
  }

  async createMemberFilterSegment(
    businessId: string,
    segmentUpdate: CherryPayApi.MemberFilterSegmentUpdate
  ): Promise<ApiResult<CherryPayApi.MemberFilterSegmentSummaryItem>> {
    const result = await this.cherryPayClient.post(
      `/v1/${businessId}/member-filter-segments`,
      segmentUpdate
    );
    return apiResult<CherryPayApi.MemberFilterSegmentSummaryItem>(result);
  }

  async getMemberFilterSegments(
    businessId: string,
    params?: { q?: string; limit?: number; continuationToken?: string }
  ): Promise<
    ApiResult<CherryPayApi.MemberFilterSegmentQueryResultSetResponse>
  > {
    const result = await this.cherryPayClient.get(
      `/v1/${businessId}/member-filter-segments`,
      { params }
    );
    return apiResult<CherryPayApi.MemberFilterSegmentQueryResultSetResponse>(
      result
    );
  }

  async getMemberFilterSegment(
    businessId: string,
    segmentId: string
  ): Promise<ApiResult<CherryPayApi.MemberFilterSegmentSummaryItem>> {
    const result = await this.cherryPayClient.get(
      `/v1/${businessId}/member-filter-segments/${segmentId}`
    );
    return apiResult<CherryPayApi.MemberFilterSegmentSummaryItem>(result);
  }

  async deleteMemberFilterSegment(
    businessId: string,
    segmentId: string
  ): Promise<ApiResult<void>> {
    const result = await this.cherryPayClient.delete(
      `/v1/${businessId}/member-filter-segments/${segmentId}`
    );
    return apiResult<void>(result);
  }

  async updateMemberFilterSegment(
    businessId: string,
    segmentId: string,
    segmentUpdate: CherryPayApi.MemberFilterSegmentUpdate
  ): Promise<ApiResult<CherryPayApi.MemberFilterSegmentSummaryItem>> {
    const result = await this.cherryPayClient.put(
      `/v1/${businessId}/member-filter-segments/${segmentId}`,
      segmentUpdate
    );
    return apiResult<CherryPayApi.MemberFilterSegmentSummaryItem>(result);
  }

  async getRecentAndUpcomingNotificationSchedulesByFilter(
    businessId: string,
    request: CherryPayApi.RecentAndUpcomingNotificationSchedulesRequest
  ): Promise<ApiResult<CherryPayApi.CherryPassNotificationSchedule[]>> {
    const result = await this.cherryPayClient.post(
      `/cherrypay/v1/${businessId}/pass-notifications/notification-schedules/recent-and-upcoming`,
      request
    );
    return apiResult<CherryPayApi.CherryPassNotificationSchedule[]>(result);
  }

  async getUpcomingNotificationSchedulesBySegmentId(
    businessId: string,
    segmentId: string,
    excludeNotificationScheduleId?: string | null
  ): Promise<ApiResult<CherryPayApi.CherryPassNotificationSchedule[]>> {
    const result = await this.cherryPayClient.get(
      `/cherrypay/v1/${businessId}/pass-notifications/notification-schedules/by-segment/${segmentId}`
    );
    const apiRes =
      apiResult<CherryPayApi.CherryPassNotificationSchedule[]>(result);
    if (apiRes.ok && excludeNotificationScheduleId) {
      return {
        ...apiRes,
        data: apiRes.data.filter(
          (s) => s.Meta?.Id !== excludeNotificationScheduleId
        ),
      };
    }
    return apiRes;
  }
}
